import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Avatar, Stack, Typography } from '@mui/material';
import { AppBadge, AppResourceItem, AppResourceList } from '@shared';

const propTypes = {
  items: PropTypes.array.isRequired,
  pendingWork: PropTypes.object, // { courier_id: { orders, tasks } }, shown next to each courier when given
}

const CouriersList = (props) => {
  return (
    <AppResourceList
      resourceName={{ singular: I18n.t("activerecord.courier.one"), plural: I18n.t("activerecord.courier.other") }}
      items={ props.items }
      idForItem={(item) => String(item.id)}
      renderItem={(item) => {
        const { id, uid, user, editURL, active } = item;
        const pending = props.pendingWork?.[id];
        const pendingCount = pending ? pending.orders + pending.tasks : 0;
        const media = <Avatar alt={user.name}>{ user.name?.[0] }</Avatar>;

        return (
          <AppResourceItem
            id={id}
            url={editURL}
            external
            media={media}
            accessibilityLabel={`View details for ${'user'}`}
            onClick={ () => props.onClick(item) }
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              {/* A name, not a heading: the <h3> it used to sit in was only ever
                  there for the weight, and carried the browser's heading margins. */}
              <Typography variant="body1" fontWeight="bold">{user.name}</Typography>
              { !active && <AppBadge>{ I18n.t("courier.inactive") }</AppBadge> }
              {/* Pending work on an inactive courier is abandoned: nobody can finish it */}
              { pendingCount > 0 &&
                <AppBadge status={ active ? "info" : "critical" }>
                  { I18n.t("courier.pending_work.count", { count: pendingCount }) }
                </AppBadge>
              }
            </Stack>
          </AppResourceItem>
        );
      }}
    />
  );
}


CouriersList.propTypes = propTypes;

export default CouriersList;
